module.exports = __webpack_public_path__ + "img/logo-smm.5b82d87a.png";